import { defineComponent as o, createBlock as a, openBlock as n, normalizeProps as p, guardReactiveProps as l, withCtx as s, renderSlot as m, createElementVNode as d } from "vue";
import f from "../CdrIcon.vue.mjs";
const c = /* @__PURE__ */ o({
  name: "ArrowLeft",
  __name: "arrow-left",
  props: {
    props: {
      type: Object
    }
  },
  setup(r) {
    return (t, e) => (n(), a(f, p(l(r.props)), {
      default: s(() => [m(t.$slots, "default"), e[0] || (e[0] = d("path", {
        role: "presentation",
        d: "M7.415 11l3.295-3.295a1 1 0 00-1.417-1.412l-4.98 4.98a.997.997 0 00-.025 1.429l5.005 5.005a1 1 0 101.414-1.414L7.414 13H19a1 1 0 000-2H7.415z"
      }, null, -1))]),
      _: 3
    }, 16));
  }
});
export {
  c as default
};
